import type { ReactNode } from 'react';
import type { MessageKey } from '../i18n/en';
import { useLanguage } from '../context/LanguageContext';
import styles from './Tooltip.module.css';

interface TooltipProps {
  readonly text?: string;
  readonly translationKey?: MessageKey;
}

export function Tooltip({ text, translationKey }: TooltipProps): JSX.Element {
  const { t } = useLanguage();
  const content: ReactNode = translationKey ? t(translationKey) : text;

  return (
    <div className={styles.tooltipContainer} tabIndex={0}>
      <span className={styles.icon}>ⓘ</span>
      <div className={styles.bubble} role="tooltip">
        {content}
      </div>
    </div>
  );
}
